import axios from 'axios';
import { showErrorAlert } from 'utils/showError';

const axiosInst = () => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API,
  });

  instance.interceptors.request.use((config) => {
    config.headers.Authorization = window.localStorage.getItem('token');
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      console.log(error);
      if (error?.response?.status === 498) {
        localStorage.setItem('token', '');
        window.location.reload();
      }
      if (!error?.response?.data?.code) {
        if (error?.response?.data?.message) {
          showErrorAlert(error.response.data.message);
        } else if (Array.isArray(error?.response?.data)) {
          const errorArr = error?.response?.data.map((item) => item?.msg).filter((item) => item);
          const errorText = errorArr.join(', ');
          showErrorAlert(errorText);
        } else if (error?.message) {
          showErrorAlert(error?.message);
        }
      }

      return Promise.reject(error);
    },
  );
  return {
    get(path, config) {
      return instance.get(path, config);
    },

    post(path, data, config) {
      return instance.post(path, data, config);
    },

    put(path, data, config) {
      return instance.put(path, data, config);
    },

    patch(path, data, config) {
      return instance.patch(path, data, config);
    },

    delete(path, config) {
      return instance.delete(path, config);
    },
  };
};

export default axiosInst;
